module.exports = __webpack_public_path__ + "25db1c87e2243fb9f9f0b00dfd9fc5b2.png";